import { createFileRoute } from '@tanstack/react-router'
import { HepCRouteComponent } from '@/components/hep-c/HepCRouteComponent'

export const Route = createFileRoute('/services/hep-c/')({
	head: () => ({
		meta: [
			{ title: 'Hepatitis C Treatment | Wellview Care' },
			{
				name: 'description',
				content:
					'Explore our comprehensive Hepatitis C (HCV) treatment services at Wellview Care in Fort Lauderdale, Fort Pierce and Riviera Beach. Learn about testing, EPCLUSA®, Mavyret, Vosevi, and the advantages of our patient-centered approach.',
			},
			{
				name: 'keywords',
				content: 'Hepatitis C Treatment, HCV Testing, EPCLUSA, Mavyret, Vosevi, Riviera Beach, Fort Lauderdale, Fort Pierce Healthcare, Florida',
			},
		],
	}),
	component: HepCRouteComponent,
})
